// extracted by mini-css-extract-plugin
export default {"label":"styles_label__0dwzD","default_color":"styles_default_color__TCK6g","error_color":"styles_error_color__7CU21","character_length":"styles_character_length__6qynH"};